<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-6 offset-xl-3">
          <card>
            <template slot="header">
              <h4 class="card-title">Pagina riservata</h4>
            </template>
            <p>La pagina che stai cercando è riservata.</p>
            <p v-if="isAuth">Torna alla <router-link :to="{path:'/'}">pagina iniziale</router-link></p>
            <p v-if="!isAuth">Via alla <router-link :to="{path:'/login'}">pagina di accesso</router-link></p>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  export default {
    components: {
      Card
    },
    computed: {
      isAuth: function () {
        return this.$root.isAuth
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/GeneralViews/NotAuthorized.vue